import * as angular from "angular";
import {IController} from "angular";
import {PlanningCommonService} from "../../services/planning-coomon-service.service";

export class PlanningActivityServiceAreasOverviewComponent implements IController {
  activity: any;
  route: any;
  serviceAreas: any;
  onClose: Function;

  private routeColor: any;

  constructor(private planningCommonService: PlanningCommonService) {
  }

  $onInit() {
    this.routeColor = this.planningCommonService.getRouteColor(this.route);
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningActivityServiceAreasOverview', {
    bindings: {
      activity: '<',
      route: '<',
      serviceAreas: '<',
      onClose: '&'
    },
    template: require('./planning-activity-service-areas-overview.html').default,
    controller: PlanningActivityServiceAreasOverviewComponent
  });

